import axios from 'axios'

// Same origin in production (server serves both API and built frontend);
// Vite's dev proxy forwards these paths to the API during development.
const api = axios.create({
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
})

api.interceptors.response.use(
  response => response.data,
  error => {
    let message = 'An unexpected error occurred'
    if (error.response) {
      message = error.response.data?.error?.message || `Server error (${error.response.status})`
    } else if (error.request) {
      message = error.code === 'ECONNABORTED'
        ? 'Request timeout - please try again'
        : 'Unable to connect to server'
    } else if (error.message) {
      message = error.message
    }
    return Promise.reject(new Error(message))
  }
)

export const healthCheck = () => api.get('/health')

export default api
